import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';

import { useEffect, useMemo } from 'react';
import { useVote } from './hooks/useVote';
import { Question } from './components/Question/Question';
import { AnimatePresence, motion } from 'motion/react';

import Advt from './components/Advt/Advt';
import { ResultQuiz } from './components/ResultQuiz/ResultQuiz';
import { useMediaLoader } from './hooks/useMediaLoader';

import defaultBackground from './assets/images/bgPoster.png';
import logoVideo from './assets/video/logoVideo.webm';
import { MessagesList } from './components/MessagesList/MessagesList';

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, messagesRef, winnerMessage, speed, setSpeed } =
    useCarousel();

  const { bg, speedSlow, speedFast, authorFontSize } = useGetParams();

  useEffect(() => {
    setTimeout(() => {
      if (currentState === 'S5' && speed !== speedSlow) {
        setSpeed(speedSlow);
      } else if (currentState === 'S6' && speed !== speedFast) {
        setSpeed(speedFast);
      }
    }, [500]);
  }, [currentState]);

  const srcVideo = useMemo(() => {
    let correctVar = voteState?.vars?.find((el) => el.correct);
    if (correctVar) {
      let keyWords = JSON.parse(correctVar?.name || {}) || [];
      let numberPlayer = keyWords.find((word) => {
        const num = Number(word);
        if (!isNaN(num) && word !== '') {
          return num;
        } else return false;
      });

      const protocol = window?.location.protocol || 'https:';
      return numberPlayer
        ? `${protocol}//stream-test.iactive.pro/sibir-hk/videos/${numberPlayer}.mp4`
        : numberPlayer;
    } else return false;
  }, [voteState?.vars]);

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  // контроль загрузки медиа
  const { isFullyLoaded } = useMediaLoader(srcVideo, 'video');

  return (
    <div
      className="app-wrapper"
      style={{ '--speed': `${speed}ms`, background }}
    >
      <AnimatePresence>
        {['S1', 'S2'].includes(currentState) && (
          <motion.div
            transition={{ duration: 0.5, delay: 0 }}
            exit={{ opacity: 0 }}
            className="logoBlock"
            key="logoBlock"
          >
            <video autoPlay="autoplay" muted="muted" playsInline>
              <source src={logoVideo} type="video/webm"></source>
            </video>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <Question title={voteState?.title} key="question" />
        )}
        {currentState === 'S2' && <Advt key="advt" />}

        {currentState === 'S3' && isFullyLoaded && (
          <ResultQuiz key={srcVideo} playerSrc={srcVideo} />
        )}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <MessagesList
            key="msgList"
            winId={winnerMessage?.message.id}
            messages={showedMessages}
            authorFontSize={authorFontSize}
            currentState={currentState}
            speed={speed || 0}
            messagesRef={messagesRef}
          />
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
